import { EventType } from '@azure/msal-browser'
import { useMsal } from '@azure/msal-react'
import { useEffect } from 'react'
import { useAppDispatch } from '@/redux/hooks'
import { setCwsDirect } from '../slice'

export const useSetFirstLogin = () => {
  const { instance } = useMsal()
  const dispatch = useAppDispatch()

  useEffect(() => {
    instance.enableAccountStorageEvents()

    const eventCallback = instance.addEventCallback((message) => {
      if (message.eventType === EventType.LOGIN_SUCCESS) {
        dispatch(setCwsDirect({ isFirstLogin: true }))
      }
    })

    return () => {
      instance.disableAccountStorageEvents()
      if (eventCallback) instance.removeEventCallback(eventCallback)
    }
  }, [])
}
